export default defineAppConfig({
    ui: {
      // NEW TAILWIND CONFIGURATION
      colors: {
        'status-green': 'green',
        'status-red': 'red',
        'status-yellow': 'yellow',
        'status-gray': 'gray'
      },

      button: {
        slots: {
          base: 'cursor-pointer disabled:cursor-not-allowed disabled:opacity-50'
        }
      },
      input: {
        slots: {
          base: 'bg-input-bg'
        }
      },
      drawer: {
        slots: {
          content: 'bg-card-primary',
          header: 'bg-card-primary',
          body: 'bg-card-primary',
          footer: 'bg-card-primary',
        },
      },
      modal: {
        slots: {
          content: 'bg-card-primary',
        },
      },
      card: {
        slots: {
          header: 'p-4 sm:px-6 bg-card-inset border-b border-gray-200 dark:border-[var(--ui-border-muted)]',
          footer: 'p-4 sm:px-6 bg-card-inset border-t border-gray-200 dark:border-[var(--ui-border-muted)]',
        },
      },
      table: {
        slots: {
          root: 'overflow-auto grid'
        },
        thead: 'sticky sticky-thead-border-bottom',
        wrapper: 'relative sm:rounded-lg',
        divide: 'divide-none',
        td: {
          base: 'whitespace-normal',
          padding: 'px-6 py-4'
        },
        th: {
          padding: 'px-6 py-4',
          color: 'text-text-secondary',
          font: 'font-semibold',
          
        },
        tr: {
          base: 'border-b border-gray-200 dark:border-[var(--ui-border)] bg-white dark:bg-card-primary',
          selected: 'bg-primary-50 dark:bg-primary-900/20',
          active: 'hover:bg-gray-50 dark:hover:bg-card-secondary cursor-pointer transition-colors duration-200'
        }
      },
    }
  })
